import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

const JourneyWithinLanding = lazy(() =>
  import("@/pages/JourneyWithinLanding")
);
const IntakeForm = lazy(() => import("@/pages/IntakeForm"));

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="flex min-h-screen items-center justify-center bg-black text-white/70 text-sm">
              Loading…
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<JourneyWithinLanding />} />
            <Route path="/intake220126" element={<IntakeForm />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
